import {useQuery} from 'react-query'
import {deleteBusBrand, fetchBusBrandList} from './api'
import {PageTitle} from '../../../_metronic/layout/core'
import {Error500} from '../../modules/errors/components/Error500'
import CRUDTable from '../../../components/table/CRUDTable'
import toast, {Toaster} from 'react-hot-toast'
import DeleteButton from '../../../components/DeleteButton'
import ModalWithForm from '../../../components/ModalWithForm'
import EditBtn from '../../../components/EditBtn'
import {Button} from 'react-bootstrap'
import viewProps from '../viewProps'
import {Processing} from '../../../components/Loaders'
import {Helmet} from 'react-helmet'
import BusBrandForm from './Form'
import PortalDropdown from '../../../components/PortalDropdown'
import EditLabel from '../../../components/EditLabel'
import DeleteConfirmationModal from '../../../components/DeleteWarning'
import DeleteLabel from '../../../components/DeleteLabel'
import ActivePill from '../../../components/ActivePill'
import InactivePill from '../../../components/InactivePill'
import TopBarProgress from 'react-topbar-progress-indicator'

const busBrandBreadcrumbs = [
  {
    title: 'School Management',
    path: 'school-management/all-bus-brand',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

function BusBrand() {
  const {data, isError, isFetching, isLoading, refetch} = useQuery(
    'busBrandList',
    fetchBusBrandList,
    {
      refetchOnWindowFocus: false,
    }
  )
  if (isLoading) {
    return <Processing />
  }
  const cellModifier = {
    bus_type_status: ({value}) => {
      switch (Number(value)) {
        case 1:
          return <ActivePill />
        case 0:
          return <InactivePill />
        default:
          return ''
      }
    },
    Actions: ({row}) => {
      return (
        <PortalDropdown triggerProps={{className: 'btn btn-secondary px-0 py-1'}}>
          <span className="dropdown-item p-0">
            <ModalWithForm
              modalTitle={'Update Bus Brand'}
              initialValues={row.original}
              onSubmit={refetch}
              Form={BusBrandForm}
              modalAttrs={{size: 'sm'}}
              triggerClassName="d-block"
            >
              <EditLabel />
            </ModalWithForm>
          </span>
          <span className="dropdown-item p-0">
            <DeleteConfirmationModal
              triggerClassName="d-block"
              onDelete={async () => {
                const toastId = toast.loading('Deleting Please wait...')
                try {
                  const response = await deleteBusBrand(row.original.bus_type_id)
                  if (response?.status === false && response?.message) {
                    toast.error(response.message, {id: toastId})
                    return null
                  }
                  await refetch()
                  toast.success('Deleted Successfully', {id: toastId})
                } catch (error) {
                  toast.error('Something went wrong, please try again later', {id: toastId})
                }
              }}
            >
              <DeleteLabel />
            </DeleteConfirmationModal>
          </span>
        </PortalDropdown>
      )
    },
  }

  return (
    <>
      <Helmet>
        <title>TrackNAB | Bus Brand list</title>
      </Helmet>
      <PageTitle breadcrumbs={busBrandBreadcrumbs}>Bus Brand</PageTitle>
      {isError ? (
        <div className="text-center">
          <Error500 />
        </div>
      ) : (
        <CRUDTable
          data={data?.data || []}
          {...viewProps.Bus}
          fieldToLabelMap={viewProps.BusBrand.primaryFieldsToLabelMap}
          Form={BusBrandForm}
          formSize={{size: 'md'}}
          cellModifier={cellModifier}
          nonSortableColumns={['Actions']}
          headerExtras={
            <ModalWithForm
              modalTitle={'Add Bus'}
              triggerClassName="ms-auto"
              onSubmit={refetch}
              Form={BusBrandForm}
              modalAttrs={{size: 'sm'}}
            >
              <Button size="sm">Add Bus Brand</Button>
            </ModalWithForm>
          }
        />
      )}
      {isFetching && <TopBarProgress />}

      <Toaster />
    </>
  )
}

export default BusBrand
